import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import PageTitle from "../components/PageTitleCompoent";
import "../css/AddPackage.css";
import api from "../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddTrainingPackage() {
  const navigate = useNavigate();

  const [packageName, setPackageName] = useState("");
  const [duration, setDuration] = useState("");
  const [amount, setAmount] = useState("");
  const [subscribedAmount, setSubscribedAmount] = useState("");
  const [promoTag, setPromoTag] = useState("");
  const [services, setServices] = useState([]);
  const [showInput, setShowInput] = useState(false);
  const [newService, setNewService] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleAddServiceClick = () => setShowInput(true);
  const handleCloseInput = () => {
    setShowInput(false);
    setNewService("");
  };
  const handleInputChange = (e) => setNewService(e.target.value);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && newService.trim()) {
      setServices((prev) => [...prev, newService.trim()]);
      toast.success("Service added successfully!");
      setNewService("");
      setShowInput(false);
    }
  };

  const handleDeleteService = (indexToDelete) => {
    const deleted = services[indexToDelete];
    setServices((prev) => prev.filter((_, idx) => idx !== indexToDelete));
    toast.info(`Removed: ${deleted}`);
  };

  const handleSave = async () => {
    if (!packageName.trim()) {
      toast.warn(" Please enter package name");
      return;
    }
    if (!amount.trim() || !subscribedAmount.trim()) {
      toast.warn(" Please enter both prices");
      return;
    }

    const tagMapping = {
      Popular: "popular",
      "Great Deals": "great_deals",
      "Steal Deals": "steals_deals",
    };

    const newPackage = {
      package_name: packageName.trim(),
      duration: duration.trim(),
      package_amount: amount.trim(),
      subscribed_user_offer_amount: subscribedAmount.trim(),
      services: services.join(", "),
      tags: tagMapping[promoTag] || "",
    };

    try {
      setIsLoading(true);
      const res = await api.post("/training-packages/", newPackage);
      toast.success(" Package saved successfully!");
      setTimeout(() => {
        navigate(-1, {
          state: {
            newPackage: {
              id: res.data.id,
              title: res.data.package_name,
              points: res.data.services ? res.data.services.split(",") : [],
              subscribedPrice: res.data.subscribed_user_offer_amount,
              unsubscribedPrice: res.data.package_amount,
              tag: res.data.tags,
            },
          },
        });
      }, 1200);
    } catch (error) {
      console.error("Error saving training package:", error);
      toast.error("❌ Failed to save package. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Add-package-container">
      <Sidebar />
      <div className="Add-package-main">
        <Header />
        <div className="Add-package-content">
          <PageTitle title="Add Training Package" onBack={() => navigate(-1)} />

          <motion.div
            className="Add-package-grid"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            {/* Package Name & Duration */}
            <div className="Add-package-form-row">
              <motion.div
                className="Add-package-form-group1"
                whileHover={{ scale: 1.02 }}
              >
                <label>
                  <h3 className="Add-package-text2">Package Name</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={packageName}
                  onChange={(e) => setPackageName(e.target.value)}
                  placeholder="Enter Package Name..."
                  style={{ width: "65%" }}
                />
              </motion.div>
              <motion.div
                className="Add-package-form-group1"
                whileHover={{ scale: 1.02 }}
              >
                <label>
                  <h3 className="Add-package-text2">Duration</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  placeholder="Enter Duration..."
                  style={{ width: "65%" }}
                />
              </motion.div>
            </div>

            {/* Amount & Subscribed Amount */}
            <div className="Add-package-form-row">
              <motion.div
                className="Add-package-form-group1"
                whileHover={{ scale: 1.02 }}
              >
                <label>
                  <h3 className="Add-package-text2">Package Amount</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter Amount..."
                  style={{ width: "65%" }}
                />
              </motion.div>
              <motion.div
                className="Add-package-form-group1"
                whileHover={{ scale: 1.02 }}
              >
                <label>
                  <h3 className="Add-package-text2">
                    Subscribed User Offer Amount
                  </h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={subscribedAmount}
                  onChange={(e) => setSubscribedAmount(e.target.value)}
                  placeholder="Enter Offer Amount..."
                  style={{ width: "65%" }}
                />
              </motion.div>
            </div>

            {/* Tags */}
            <div className="Add-package-form-group1">
              <label>
                <h3 className="Add-package-text2">Tags</h3>
              </label>
              <div className="Add-package-tags-buttons">
                {["Popular", "Great Deals", "Steal Deals"].map((tagOption) => (
                  <motion.button
                    key={tagOption}
                    whileTap={{ scale: 0.95 }}
                    whileHover={{ scale: 1.05 }}
                    className={`Add-package-tag-button ${
                      promoTag === tagOption
                        ? `${tagOption.toLowerCase().replace(/\s+/g, "_")}_selected`
                        : ""
                    }`}
                    onClick={() => setPromoTag(tagOption)}
                    type="button"
                  >
                    {tagOption}
                  </motion.button>
                ))}
              </div>
            </div>

            {/* Services */}
            <div className="Add-package-form-group1">
              <label>
                <h3 className="Add-package-text2">Services</h3>
              </label>
              <div className="Add-package-service-box">
                <ul className="service-list">
                  <AnimatePresence>
                    {services.map((service, index) => (
                      <motion.li
                        key={index}
                        className="service-item"
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 30 }}
                        transition={{ duration: 0.3 }}
                      >
                        <span
                          className="service-hyphen"
                          onClick={() => handleDeleteService(index)}
                          style={{
                            cursor: "pointer",
                            color: "red",
                            marginRight: 8,
                          }}
                        >
                          −
                        </span>
                        {service}
                      </motion.li>
                    ))}
                  </AnimatePresence>
                </ul>

                {showInput ? (
                  <motion.input
                    type="text"
                    value={newService}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyPress}
                    onBlur={handleCloseInput}
                    autoFocus
                    className="service-input"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                  />
                ) : (
                  <motion.button
                    className="add-service-btn"
                    onClick={handleAddServiceClick}
                    type="button"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    +
                  </motion.button>
                )}
              </div>
            </div>

            {/* Save Button */}
            <div className="Add-package-button-wrapper">
              <motion.button
                className="Add-package-save-button"
                onClick={handleSave}
                type="button"
                disabled={isLoading}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {isLoading ? "Saving..." : "Save"}
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>

     <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
